

export type SubscriptionMode =
    "None"
    | "Single"
    | "Concurrent";